import { Session } from 'types/listings';

const getTotalPriceExcludingLast = (sessions: Session[]): number => {
  if (!sessions || sessions.length === 0) return 0;
  if (sessions.length === 1) {
    return sessions[0].priceTiers?.[0]?.price || 0;
  }
  const sorted = [...sessions].sort(
    (a, b) =>
      new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime(),
  );
  const sessionsToTotal = sorted.slice(0, -1);
  const total = sessionsToTotal.reduce((sum, session) => {
    const price = session.priceTiers?.[0]?.price || 0;
    return sum + price;
  }, 0);
  return total;
};

export default getTotalPriceExcludingLast;
